import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const PartnerDigitalAgreement = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default PartnerDigitalAgreement;